<template>
  <div>
    <span>{{ getTitle }}</span>
    <v-btn v-if="showDownload" @click.native="download()" icon>
      <v-icon> mdi-file </v-icon>
    </v-btn>
  </div>
</template>
<script>
import math from '../../mixins/math'

export default {
  name: 'ElTableDownload',
  props: {
    title: String,
    file: [Object, Array],
  },
  mixins: [math],
  computed: {
    showDownload() {
      return !Array.isArray(this.file)
    },
    getTitle() {
      return this.title ? this.$t(this.title) : ''
    },
  },
  methods: {
    download() {
      this.$axios
        .get(`uploads/${this.file.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(this.file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>

<style lang="scss" scoped></style>
